import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	organizationsListBreadcrumb: {
		id: 'fastshift.organization-details-page.parent-page-breadcrumb',
		defaultMessage: 'Organizations',
		description: 'Breadcrumb for organizations page, the parent page of organization details page',
	},
	loadingLabel: {
		id: 'fastshift.organization-details-page.loading-label',
		defaultMessage: 'Loading organization details',
		description: 'Accessible label for the organization details page loading indicator.',
	},
	dcInstancesTabLabel: {
		id: 'fastshift.organization-details-page.dc-instances-tab-label',
		defaultMessage: 'Data Center instances',
		description: 'Label for the DC instances tab in the organization details page.',
	},
	migrationPlansTabLabel: {
		id: 'fastshift.organization-details-page.migration-plans-tab-label',
		defaultMessage: 'Migration plans',
		description: 'Label for the migration plans tab in the organization details page.',
	},
});
